/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React, { Component } from 'react';
import {ISiteDetails} from "../../../stores/GatewayManager/IGatewayRegistrationInterfaces";
import DIYAppConstants from "../../../utils/DIYAppConstants";
import './Summary.scss'
import './ConfirmSiteSelection.scss'
import { observer } from 'mobx-react';
import SiteSelectionStore from '../../../stores/GatewayManager/SiteSelectionStore';

/**
 * The properties for the site selection confirmation
 */
export interface IConfirmSiteSelectionProps {
  selectedSite: ISiteDetails
  siteSelectionStore?:SiteSelectionStore
}

/**
 * This is the confirmation for site selection.
 * Once a site is selected and gateway registration is done, it cannot be re-registered
 * without a factory reset.
 * The confirmation is meant to solicit the user's consent.
 * @constructor
 */


@observer
export default class  ConfirmSiteSelection extends Component<IConfirmSiteSelectionProps>  {



  constructor(props: IConfirmSiteSelectionProps) {
    super(props);
  }

  /**
   * Renders the site details as a block
   * @param {ISiteDetails} siteDetails
   * @returns {any}
   */
  renderSiteDetails = (siteDetails: ISiteDetails) => {
    return <React.Fragment>
      {DIYAppConstants.SITE_DETAILS_BLOCK(siteDetails)}
    </React.Fragment>
  };


  render(){
    return <div className='ui-confirm-site-sel-root'>
    <div className='ui-confirm-msg site-loc-msg'>
      You have selected the following location.
    </div>
    <div className='ui-site-details-block'>
      {
        this.renderSiteDetails(this.props.selectedSite)
      }
    </div>
    <div className='ui-confirm-msg site-confirm-msg'>
      Once confirmed the selected location <b>cannot be changed</b> until the
      device is re-registered.
    </div>
  </div>
  }

}
